import { Input, Output, EventEmitter, Directive } from '@angular/core';

@Directive()
export class CustomFieldBase {
    @Input() disabled: boolean;

    @Input() value: any;
    @Output() valueChange = new EventEmitter<any>();
}